import {Box} from '@mui/material';
import ArrToast from '../../../components/common/arr-toast/ArrToast';
import {Link} from 'react-router-dom';
import {ReactComponent as SuccessIcon} from '../../../../src/assets/images/success-toast.svg';
import {ReactComponent as WarningIcon} from '../../../../src/assets/images/warning-toast.svg';
import {ReactComponent as ErrorIcon} from '../../../../src/assets/images/error-toast.svg';
import {ReactComponent as CloseToast} from '../../../../src/assets/images/close-toast.svg';

const ToastDemo = () => {
  return (
    <Box className="demo-page" mt={20}>
      <h1>ARR Toast</h1>
      <Link to="/demo" className="link">
        {' '}
        Return back to demo
      </Link>
      <ArrToast
        id="toast-1"
        title="Success!"
        message="Ingestion summary report has been added to background process. You will get a notification on completion."
        type="success"
        duration={5000}
        onClose={(id) => console.log(`Toast ${id} closed`)}
        dismissable={true}
        // showStartIcon={true}
        // startIcon={<SuccessIcon />}
        closeIcon={<CloseToast />}
        position="bottom-right"
      />
      <ArrToast
        id="1"
        startIcon={<SuccessIcon />}
        showStartIcon={true}
        title="Lorem ipsum dolor amet sit."
        type="success"
        duration={5000}
        onClose={(id) => console.log(`Toast ${id} closed`)}
        position="bottom-center"
      />
      <br />
      <ArrToast
        id="1"
        startIcon={<WarningIcon />}
        showStartIcon={true}
        title="Lorem ipsum dolor amet sit."
        type="warning"
        duration={5000}
        onClose={(id) => console.log(`Toast ${id} closed`)}
        position="top-left"
      />
      <br />
      <ArrToast
        id="1"
        startIcon={<WarningIcon />}
        showStartIcon={true}
        title="Lorem ipsum dolor amet sit."
        type="warning"
        duration={5000}
        onClose={(id) => console.log(`Toast ${id} closed`)}
        position="bottom-left"
      />
      <br />
      <ArrToast
        id="1"
        startIcon={<ErrorIcon />}
        showStartIcon={true}
        title="Lorem ipsum dolor amet sit."
        type="error"
        duration={5000}
        onClose={(id) => console.log(`Toast ${id} closed`)}
        position="center"
      />
      <br />
      <ArrToast
        id="toast-1"
        title="Success!"
        duration={5000}
        message="Ingestion summary report has been added to background process. You will get a notification on completion."
        type="success"
        onClose={(id) => console.log(`Closed toast ${id}`)}
        dismissable={true}
        closeIcon={<CloseToast />}
      />
    </Box>
  );
};
export default ToastDemo;
